"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.warehousePolygonSchema = void 0;
const WarehousePath_1 = require("./WarehousePath");
const yup = require("yup");
exports.warehousePolygonSchema = yup.object().shape({
    id: yup.string().required(),
    activePathId: yup.string(),
    paths: yup.array().of(WarehousePath_1.warehousePathSchema).required(),
});
//# sourceMappingURL=WarehousePolygon.js.map